import { paymentGatewayApi } from "@api/instances";
import { ApiResponse } from "@api/apiRequest";
import rollbar, { LogMetadata } from "@utils/rollbar";

const deletePaymentMethod = async (
  paymentMethodId: string,
): Promise<ApiResponse<null>> => {
  try {
    await paymentGatewayApi.delete(
      `/v1/billing/payment-methods/${paymentMethodId}`,
      { requireAuth: true },
    );
    return { data: null, success: true, error: "" };
  } catch (e) {
    const err = e instanceof Error ? e : new Error("Unknown error");
    const meta: LogMetadata = { endpoint: "/v1/billing/payment-methods/:id", method: "DELETE", paymentMethodId };
    rollbar.error(err, meta);
    return { data: null, success: false, error: "Failed to delete payment method" };
  }
};

export default deletePaymentMethod;
